import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import {ArrowLeftOutlined} from "@ant-design/icons";
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import {header} from "../../../../../../../../components/api/Header";
import { getEnv } from "../../../../../../../../lib/env";

function Limit4() {
    const lkoifsent = localStorage.getItem('sfr-hm-veg-koifsent') ? localStorage.getItem('sfr-hm-veg-koifsent') : 1
    const user = user_data()
    const year = localStorage.getItem('sfr-hm-year') ? localStorage.getItem('sfr-hm-year') : new Date().getFullYear()
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba ? JSON.parse(manba) : []
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist ? JSON.parse(ist) : []
    const [swed, setSwed] = useState({})
    const ekin = localStorage.getItem("sfr-hm-veg-ekinlar")
    const ekinlar = ekin ? JSON.parse(ekin) : {}
    const ste1 = localStorage.getItem("sfr-hm-ste")
    const sfrsanoat = ste1 ? JSON.parse(ste1) : {}
    const sfrMaydon = localStorage.getItem("sfr-hm-veg-maydon")
    const sfrMaydonlar = sfrMaydon ? JSON.parse(sfrMaydon) : {}
    const [maydonlar, setMaydonlar] = useState({})
    const daysindek = decade_days('veg', year)
    const cropid = localStorage.getItem('sfr-hm-veg-ekinids')
    const cropids = cropid ? JSON.parse(cropid) : []

    useEffect(() => {
        let gmss = []
        const fetchSwed = async (gmss, gmss2) => {
            const postData = {
                crops: cropids,
                gmss,
                maydonlar: gmss2,
                tomorqa1: false
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/veg_sugorish_meyyori2",
                postData,
                header()
            )
                .catch(e => {
                    console.log("Xato", e)
                })
            if (res) {
                setSwed(res.data)
            }
        }
        const maydon = () => {
            let gidromodullar = []
            istemolchilar.map(i => {
                if (i.gms) {
                    i.gms.map(g => {
                        if (!gidromodullar.includes(g)) {
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydon()
        const gmss2 = gmslar(sfrMaydonlar, cropids)
        setMaydonlar(gmss2)
        if (gmss2)
            fetchSwed(gmss, gmss2)
    }, [])
    const ff = (ist, fik) => {
        if (!ist.gms) return 0
        if (!ist.gms.length) return 0
        let res = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (let deks = 1; deks < 19; deks++) {
            let bm = 0
            let jbm = 0
            Object.keys(ekinlar).map(e => {
                let nm = 0
                let jnm = 0
                if (swed[e.slice(1)]) {
                    ist.gms.map(gms2 => {
                        if (swed[e.slice(1)][gms2]) {
                            let jm = maydonlar['g' + gms2] ? maydonlar['g' + gms2][e] : 0
                            let im = sfrMaydonlar['i' + ist.id] ? sfrMaydonlar['i' + ist.id]['g' + gms2] ? sfrMaydonlar['i' + ist.id]['g' + gms2][e] : 0 : 0
                            let ds = swed[e.slice(1)][gms2][deks] * 1 / 0.0864 / daysindek['d' + deks]
                            let jds = swed[e.slice(1)][gms2][deks]
                            nm = addFunc(nm, (bolFunc(im, jm) * ds))
                            jnm = addFunc(jnm, (bolFunc(im, jm) * jds))
                        }
                    })
                    bm = addFunc(bm, bolFunc(nm, fik))
                    jbm = addFunc(jbm, bolFunc(jnm, fik))
                }
            })
            res[deks - 1] = bm > 0 ? bm : 0
            res[18] = addFunc(res[18], jbm > 0 ? jbm : 0)
        }
        return res
    }
    const xisobot = () => {
        if (manbalar.length) {
            let obj = [];
            let jm = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let sug = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            let stem = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            manbalar.map((manba, i) => {
                sug = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                jm = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                stem = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                let istemolchi = istemolchilar.filter(istemolchi => istemolchi.mid == manba.id)
                if (istemolchi.length) {
                    istemolchi.map(ist => {
                        let ms = ff(ist, manba.fik)
                        if (ms.length) {
                            ms.map((m, mi) => {
                                sug[mi] = addFunc(sug[mi], (m * lkoifsent))
                                return null
                            })
                        }
                    })
                }
                let sanoat = sfrsanoat.filter(s => s.manba == manba.id)
                for (let d = 1; d < 19; d++) {
                    let wq = 0
                    if (sanoat.length) {
                        sanoat.map(s => {
                            let q = bolFunc(s['d' + d], manba.fik)
                            wq = addFunc(wq, q)
                        })
                    }
                    stem[d - 1] = wq
                    jm[d - 1] = addFunc(stem[d - 1], sug[d - 1])
                    stem[18] = addFunc(stem[18], bolFunc(stem[d - 1], (1 / 0.0864 / daysindek['d' + d])))
                }
                jm[18] = addFunc(stem[18], sug[18])
                obj.push(
                    <tr key={i + "n"}>
                        <td rowSpan={4}>{i + 1}</td>
                        <th className="text-start">{manba.name}</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )
                obj.push(
                    <tr key={i + "j"}>
                        <td className="text-end pe-1">Jami</td>
                        {
                            jm.map((j, ji) => {
                                return <td key={ji}>{j?fixIt(j / 1000,4):''}</td>
                            })
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i + "s"}>
                        <td className="text-end pe-1">Sh.j sug'orishga</td>
                        {
                            sug.map((s, si) => {
                                return <td key={si}>{s?fixIt((s / 1000),4):''}</td>
                            })
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i + "ste"}>
                        <td className="text-end pe-1">STE va boshqalar</td>
                        {
                            stem.map((s, si) => {
                                return <td key={si}>{s?fixIt(s / 1000,4):''}</td>
                            })
                        }
                    </tr>
                )

            })
            return obj;
        }
    }
    return (

        <div className="row">
            <div className="col-12">
                <table className="table table-borderless">
                    <thead>
                    <tr>
                        <td colSpan={21}><h3 className="text-center">Limit - №4</h3></td>
                    </tr>
                    <tr>
                        <td colSpan={21}>
                            <h4 className="text-center">
                                {user.district} bo'yicha {year} - yil sug'orish davrida suv manbalaridan olinadigan
                                cheklangan suv miqdori (limit)
                            </h4>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-5">m<sup>3</sup>/sek</div>
                <div className="flex-box">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background: "#77adba", color: "#fff"}}>
                            <tr>
                                <th rowSpan={2}>No</th>
                                <th rowSpan={2}>Kanallar nomi</th>
                                {
                                    season_month('veg').map((m, i) => {
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                                <th rowSpan={2}>Hajmi <br/> mln.m<sup>3</sup></th>
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Limit4;